import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";

export default function VerifyEmail() {
  const userState = useSelector((state) => state.user);

  const isGamePlayerVerified = useSelector(
    (state) =>
      state.user?.profile?.isEmailVerified ||
      state.user?.profile?.isPhoneVerified
  );

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (userState?.isAuthenticated && !isGamePlayerVerified) {
      const redirectPath = location.pathname;
      let path = "/verify-email";

      if (path === redirectPath) {
        return;
      }

      if (redirectPath?.length > 0 && redirectPath !== path) {
        path += `?redirect=${redirectPath}`;
      }

      history.push(path);
    }
  }, [userState?.isAuthenticated, isGamePlayerVerified, history, location]);

  return null;
}
